import {
  format,
  isToday as isTodayFn,
  startOfDay,
  startOfWeek,
  endOfWeek,
  isSameDay,
  isAfter,
  isBefore,
  subDays,
} from "date-fns";
import { pl } from "date-fns/locale";

export function formatPL(date: Date, pattern = "PPP"): string {
  return format(date, pattern, { locale: pl });
}

export function formatRelativeDay(date: Date): string {
  if (isTodayFn(date)) return "dzisiaj";
  if (isSameDay(date, subDays(new Date(), 1))) return "wczoraj";
  return format(date, "EEEE, d MMM", { locale: pl });
}

export function todayMidnight(): Date {
  return startOfDay(new Date());
}

export function isToday(date: Date): boolean {
  return isTodayFn(date);
}

export function weekRange(date = new Date()): { start: Date; end: Date } {
  return {
    start: startOfWeek(date, { weekStartsOn: 1, locale: pl }),
    end: endOfWeek(date, { weekStartsOn: 1, locale: pl }),
  };
}

export function startOfThisWeek(date = new Date()): Date {
  return startOfWeek(date, { weekStartsOn: 1, locale: pl });
}

/**
 * Wiek dziecka z roku urodzenia. Granularność roczna — wystarczająca dla
 * preset wiekowych (8-latek vs 9-latek mieści się w tej samej kohorcie).
 * Zwraca 0 dla edge case'a `today.year < birthYear` (np. literówka).
 */
export function ageFromBirthYear(birthYear: number, today = new Date()): number {
  const diff = today.getFullYear() - birthYear;
  return Math.max(0, diff);
}

export { isAfter, isBefore, isSameDay };
